export const tables = {
    orientation: [{
        name: 'ORIENTATION',
        key: 'display_name',
        link: '',
        sort: false,
    },
    {
        name: 'ORIENTATION HEADER TEXT',
        key: 'header_text',
        link: '',
        sort: false,
    },
    {
        name: 'IMBALANCE INTRODUCTION',
        key: 'imbalance_introduction',
        link: '',
        sort: false,
    }],
    inference: [{
        name: 'CODE',
        key: 'code',
        link: '',
        sort: false,
    },
    {
        name: 'INFERENCE TEXT',
        key: 'inference_text',
        link: '',
        sort: false,
    }],
    implications: [{
        name: 'CODE',
        key: 'code',
        link: '',
        sort: false,
    },
    {
        name: 'TEXT',
        key: 'text',
        link: '',
        sort: false,
    }],
    actionItems: [{
        name: 'ATTRIBUTE',
        key: 'attribute',
        link: '',
        sort: false,
    },
    {
        name: 'CODE',
        key: 'code',
        link: '',
        sort: false,
    },
    {
        name: 'TEXT',
        key: 'text',
        link: '',
        sort: false,
    }],
}


// WEBPACK FOOTER //
// ./src/_pages/Admin/ReportContent/ReportDetails/tableData.js